import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CalculatorOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { useQuery } from 'src/core/utils/formater';
import newAlert from 'src/components/newAlert';
import { Button as AntButton } from 'antd';
import { Spin } from 'antd';
import { Table } from 'src/components';
import { customConfirm } from 'src/components/common/confirmModal';
import {
  ColumnsMain,
  customSummary,
  ColumnsDansMain,
  customDansSummary,
} from './dataStructure/data';
import { searchList } from './dataStructure/search';
import { start_loading, end_loading } from '../../../core/actions/loader';
import BurtgeList from './BurtgeList';

const UndsenHurunguTovchoo = () => {
  const dispatch = useDispatch();
  const [calcEnd, seTcalcEnd] = useState('');
  const antIcon = <div className="whirly-loader" />;
  const query = useQuery();
  const history = useHistory();

  const socket = useSelector((state) => state.socket);
  const data_date = useSelector((state) => state.data_date);

  const [sumType, seTsumType] = useState();
  const [selectedHurungu, seTselectedHurungu] = useState({});
  const [burtgel, seTburtgel] = useState(false);
  const [tableData, setTableData] = useState({
    result_list: [],
    result_json: {},
    total_list: {},
    total_size: 0,
    validtion_info: {
      validated: true,
      error_message: [],
    },
  });

  const select_data = () => {
    socket.on('request_out', (data) => {
      socket.removeAllListeners('request_out');
      if (data.status === '0') {
        console.log(data?.content);
        if (data?.content?.processing) {
          seTcalcEnd(`Татварын товчоо тооцоологдож байна. Дуусах хугацаа: ${data.content?.data_json.end}`);
        }
        else {
          seTcalcEnd('');
          setTableData(data?.content);
        }
      } else {
        newAlert({ type: 'error', msg: 'Системд алдаа гарлаа' });
      }
      dispatch(end_loading({}));
    });
    const page = query.get('page');
    const size = query.get('size') || 50;
    const { month } = data_date;
    const search = {
      type: sumType || 'hurungu',
      dans_dugaar: query.get('dans_dugaar'),
      hurungu: query.get('hurungu'),
    };
    socket.emit('request_in', {
      channel: 'ts003_view',
      content: {
        action_type: 'tatvar_tovchoo_page',
        month,
        page,
        size,
        search,
      },
    });
    dispatch(start_loading({}));
  };

  const onSelectHurungu = (row) => {
    seTselectedHurungu(row);
    seTburtgel(true);
  };

  const clearPage = () => {
    const proplist = ['page', 'size'];
    let not_change = true;
    proplist.forEach((name) => {
      if (query.get(name)) {
        query.delete(name);
        not_change = false;
      }
    });
    if (not_change) {
      select_data();
    } else {
      history.push({ search: query.toString() });
    }
  };

  useEffect(() => {
    if (sumType) {
      clearPage();
    }
  }, [sumType]);

  useEffect(() => {
    select_data();
  }, [query, data_date]);

  const cal_tatvar_tovchoo = () => {
    socket.on('request_out', (data) => {
      if (data.status === '0') {
        socket.removeAllListeners('request_out');
        seTcalcEnd('');
        newAlert({ type: 'success', msg: 'Товчоо амжилттай тооцооллоо' });
        dispatch(end_loading({}));
        select_data();
      } else if (data.status === '1') {
        socket.removeAllListeners('request_out');
        newAlert({ type: 'error', msg: data.message });
        dispatch(end_loading({}));
        select_data();
      } else if (data.status === '3') {
        // Санхүүгийн товчоо тооцоологдож байна. Дуусах хугацаа:
        seTcalcEnd(`Татварын товчоо тооцоологдож байна. Дуусах хугацаа: ${data.content?.end}`);
        dispatch(end_loading({}));
        newAlert({ type: 'warning', msg: data.message });
      } else {
        socket.removeAllListeners('request_out');
        newAlert({ type: 'error', msg: 'Системд алдаа гарлаа' });
        dispatch(end_loading({}));
        select_data();
      }
    });
    const { month } = data_date;
    socket.emit('request_in', {
      channel: 'ts003_calculate',
      content: { action_type: 'cal_tatvar_tovchoo', month },
    });
    dispatch(start_loading({}));
  };

  const title = () => (
    <>
      <AntButton
        className="add-btn"
        type="primary"
        size="small"
        icon={<CalculatorOutlined />}
        onClick={() => {
          customConfirm({
            title: 'Татварын товчоо тооцоолохыг зөвшөөрөх үү?',
            onOk: () => cal_tatvar_tovchoo(),
          });
        }}
      >
        Товчоо тооцоолох
      </AntButton>
      <AntButton
        className="add-btn"
        type="primary"
        size="small"
        onClick={() => {
          seTsumType(sumType === 'dans' ? 'hurungu' : 'dans');
        }}
      >
        {sumType === 'dans' ? 'Дансаар' : 'Хөрөнгөөр'}
      </AntButton>
    </>
  );

  const mainTable = () => (
    <div className="table-antd-div no-scroll">
      <Table
        isSearch
        searchList={searchList}
        title={title}
        columns={ColumnsMain({ onSelectHurungu })}
        total={tableData.total_size}
        dataSource={tableData.result_list}
        scroll={{
          y: 'calc(100vh - 390px)',
        }}
        customize={() => customSummary({ data: tableData.total_list })}
      />
    </div>
  );

  const mainDansTable = () => (
    <div className="table-antd-div no-scroll">
      <Table
        isSearch
        searchList={searchList}
        title={title}
        columns={ColumnsDansMain()}
        total={tableData.total_size}
        dataSource={tableData.result_list}
        scroll={{
          y: 'calc(100vh - 390px)',
        }}
        customize={() => customDansSummary({ data: tableData.total_list })}
      />
    </div>
  );

  const onCancelBurtgel = () => {
    seTburtgel(false);
  };

  return (
    <>
      <BurtgeList
        hurunguData={selectedHurungu}
        closeDrawer={onCancelBurtgel}
        open={burtgel}
      />
      {calcEnd ? (
        <div className="calc-end-message" >
          <Spin
            indicator={antIcon}
            spinning={true}
          />
          {calcEnd}
          <AntButton
            className="add-btn"
            type="primary"
            // size="big"
            icon={<CalculatorOutlined />}
            onClick={() => {
              seTcalcEnd('');
              select_data();
            }}
          >
            Шинэчлэх
          </AntButton>
        </div>
      ) : (
        sumType === 'dans' ? mainDansTable() : mainTable()
      )}
    </>
  );
};

export default UndsenHurunguTovchoo;
